import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { AutoAwesomeRounded as AutoAwesomeIcon } from '@mui/icons-material';
import colors from '../../assets/theme/colors';
import {
  ASK_ACCENT,
  ASK_ACCENT_DARK,
} from './askRecordUi';

const AskRecordThinkingDots = ({ compact }) => (
  <Box
    aria-hidden="true"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: compact ? 0.28 : 0.34,
      '@keyframes askRecordDotDance': {
        '0%, 80%, 100%': {
          opacity: 0.42,
          transform: 'translateY(0) scale(0.84)',
        },
        '40%': {
          opacity: 1,
          transform: 'translateY(-5px) scale(1)',
        },
      },
    }}
  >
    {[0, 1, 2].map((dotIndex) => (
      <Box
        component="span"
        key={dotIndex}
        sx={{
          width: compact ? 5 : 6,
          height: compact ? 5 : 6,
          borderRadius: '999px',
          bgcolor: 'currentColor',
          animation: 'askRecordDotDance 960ms ease-in-out infinite',
          animationDelay: `${dotIndex * 130}ms`,
        }}
      />
    ))}
  </Box>
);

const AskRecordThinkingState = ({ compact = false, firstName }) => {
  const label = firstName ? `Reading ${firstName}'s logs` : 'Reading saved logs';

  return (
    <Box
      aria-label={label}
      role="status"
      sx={{
        position: 'relative',
        zIndex: 1,
        mt: compact ? 0.85 : 1,
        display: 'grid',
        gridTemplateColumns: `${compact ? 32 : 36}px minmax(0, 1fr)`,
        alignItems: 'center',
        gap: 0.72,
      }}
    >
      <Box
        sx={{
          width: compact ? 30 : 34,
          height: compact ? 30 : 34,
          borderRadius: '12px',
          display: 'grid',
          placeItems: 'center',
          bgcolor: ASK_ACCENT,
          color: '#FFFFFF',
          boxShadow: `0 10px 20px ${alpha(ASK_ACCENT_DARK, 0.2)}`,
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: compact ? 16 : 18 }} />
      </Box>
      <Box
        sx={{
          width: 'fit-content',
          maxWidth: '100%',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.7,
          px: compact ? 0.9 : 1.05,
          py: compact ? 0.68 : 0.78,
          borderRadius: '18px',
          bgcolor: alpha('#FFFFFF', 0.86),
          border: `1px solid ${alpha(ASK_ACCENT, 0.18)}`,
          color: ASK_ACCENT_DARK,
          boxShadow: `0 10px 22px ${alpha(ASK_ACCENT, 0.08)}`,
        }}
      >
        <Typography
          sx={{
            minWidth: 0,
            color: colors.semantic.ink,
            fontSize: compact ? '0.8rem' : '0.88rem',
            lineHeight: 1.1,
            fontWeight: 850,
          }}
        >
          {label}
        </Typography>
        <AskRecordThinkingDots compact={compact} />
      </Box>
    </Box>
  );
};

export default AskRecordThinkingState;
